// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions"; 

const firebaseConfig = {
  apiKey: "AIzaSyAv8HWudvBKxgXinj361nrxyLtX-zEx0K4",
  authDomain: "aulice-hub.firebaseapp.com",
  projectId: "aulice-hub",
  storageBucket: "aulice-hub.firebasestorage.app",
  messagingSenderId: "966761974696",
  appId: "1:966761974696:web:bd987a5e805f9bb9ba2b9d"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1"); 

export { app, auth, db, functions };